function init_dildoanim(fromPhp) {
  var main = $(".place.dildoanim");

  if(main.find("#lickAnim").length>0) {
    initLickAnim();
  }

  function initLickAnim() {
      var animIndexQueue=_moduleTimeHandler.getNewIndex();
      var anim_conf=$.takeGirlConf(1011,"fight_png"),i,girl_img=$.takeGirlImage(1011);
      for(i in anim_conf){
          anim_conf[i]={"path":_IMG_SERV+"/gfx/place/fight/animation/"+girl_img+"/"+i+"/anim.png","conf":anim_conf[i]};
      }
      var qcanv=main.find("#lickAnim").show().removeClass("hide");;
      qcanv =qcanv.find(".canvMain");
      qcanv.off("was_loaded").one("was_loaded",function(){
          qcanv.animCircle("addSteps",[{howlong:4000,"end_val":0}]);
          _moduleTimeHandler.set(animIndexQueue,function(){
              if(qcanv.animCircle("howlongRemain")<5000) {
                  qcanv.animCircle("addSteps", [{howlong: 4000, "end_val": 0}]);
              }
              if (intval(qcanv.attr("cumshot")) === 1) {
                  qcanv.animCircle("setSteps", [{howlong: 500, "end_val": 0}, {howlong: -1, "end_val": "end"}]);
                  _moduleTimeHandler.clear(animIndexQueue);
              }
          },3000);
          qcanv.animCircle("start")

      }).animCircle({},anim_conf,_moduleTimeHandler);
      main.find("#cumButton").off().one("click",function () {
          $(this).animate({opacity:0},1000);
          qcanv.attr("cumshot",1);
      });
  }
}
